import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
const VIEWER_SEQUENCE = [15, 16, 18, 20];
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 24,
    seconds: 23
  });
  const [viewerIndex, setViewerIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Live viewers counter: cycles 15 -> 16 -> 18 -> 20 -> back to 15, with a
  // slightly randomized interval so it doesn't feel mechanical.
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const tick = () => {
      setViewerIndex(prev => (prev + 1) % VIEWER_SEQUENCE.length);
      timeout = setTimeout(tick, 4000 + Math.random() * 3000);
    };
    timeout = setTimeout(tick, 4000 + Math.random() * 3000);
    return () => clearTimeout(timeout);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const viewers = VIEWER_SEQUENCE[viewerIndex];
  return <section className="py-5 md:py-10 px-4" data-id="element-14" data-mp="f2kgpmb99yik">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-2xl mx-auto bg-slate-900 rounded-[2rem] p-6 md:p-10 text-center shadow-2xl border border-white/5" data-id="element-15" data-mp="a3r3luzvs9ix">
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-16" data-mp="1zi5og47s3c95">
          <span className="text-xl md:text-2xl" data-id="element-17" data-mp="1zgcjqugq723s">⏰</span>
          <h2 className="text-lg md:text-2xl font-black text-white uppercase tracking-tight leading-tight" data-id="element-18" data-mp="1vhbzd7ilnreo">
            EL PRECIO DE <br className="md:hidden" data-id="element-19" data-mp="s4vaxqmffuld" /> LANZAMIENTO TERMINA EN:
          </h2>
        </div>

        <div className="flex justify-center items-center gap-3 md:gap-6 mb-6" data-id="element-20" data-mp="x3g9llm1667p">
          {[{
          val: timeLeft.hours,
          label: 'HS'
        }, {
          val: timeLeft.minutes,
          label: 'MIN'
        }, {
          val: timeLeft.seconds,
          label: 'SEG'
        }].map((item, i) => <Fragment key={i} data-id="element-21" data-mp="9ggg0s8znwfa" data-mpi={i}>
              <div className="flex flex-col" data-id="element-22" data-mp="9d2hjv3g47d4">
                <span className="text-4xl md:text-6xl font-black text-rose-500 tabular-nums" data-id="element-23" data-mp="edgqrggs9ncq">
                  {formatNumber(item.val)}
                </span>
                <span className="text-[9px] md:text-[11px] font-bold text-slate-500 uppercase mt-1" data-id="element-24" data-mp="ie0jm7ubq4t2">
                  {item.label}
                </span>
              </div>
              {i < 2 && <span className="text-3xl md:text-5xl font-black text-white/20 mb-5" data-id="element-25" data-mp="3mrz2pt9uhn1m">
                  :
                </span>}
            </Fragment>)}
        </div>

        <p className="text-base md:text-lg font-bold text-white mb-8" data-id="element-26" data-mp="3jb2xik0fte78">
          <span className="text-rose-500" data-id="element-27" data-mp="3ecj9me2a9sc8">OFERTA ESPECIAL DE LANZAMIENTO</span>
          <br data-id="element-28" data-mp="3abfu5so5dybj" />
          El precio de lanzamiento es por tiempo limitado.
        </p>

        <div className="max-w-md mx-auto" data-id="element-29" data-mp="3adk52ukgrxlb">
          <div className="flex justify-between items-end mb-2" data-id="element-30" data-mp="35d5ylgyigvpe">
            <div className="flex items-center gap-2" data-id="element-31" data-mp="35ephzgfgrmve">
              <div className="w-2 h-2 bg-rose-500 rounded-full animate-pulse" data-id="element-32" data-mp="30e1p0p7ocvyj" />
              <span className="text-[9px] md:text-[11px] font-bold text-slate-400 uppercase tracking-wider" data-id="element-33" data-mp="2vmb8u2m23dz7">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-[9px] md:text-[11px] font-black text-white uppercase" data-id="element-34" data-mp="2mmo7thx8oa6o">
              Quedan pocos
            </span>
          </div>
          <div className="h-2.5 bg-white/10 rounded-full overflow-hidden mb-2" data-id="element-35" data-mp="2hov2ss7o9m7z">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gradient-to-r from-rose-600 to-orange-500 rounded-full" data-id="element-36" data-mp="2co7cy9v6jbfc" />
          </div>
          <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest mb-3" data-id="element-37" data-mp="btknadxfl8o1">
            68% de los cupos tomados
          </p>

          {/* LIVE VIEWERS */}
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-3 py-1.5" data-id="element-38" data-mp="3u1jr3p72kddy">
            <span className="relative flex h-2 w-2" data-id="element-39" data-mp="3k19ikhvzbu54">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-40" data-mp="3k2u9zymzywyr" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-41" data-mp="3p2goscih4l9o" />
            </span>
            <span className="text-[10px] md:text-xs font-bold text-slate-300" data-id="element-42" data-mp="1i83h56d44ies">
              👀{' '}
              <motion.span key={viewers} initial={{
              opacity: 0,
              y: -4
            }} animate={{
              opacity: 1,
              y: 0
            }} className="inline-block text-white font-black tabular-nums" data-id="element-43" data-mp="1n6n0cz0bng3g">
                {viewers}
              </motion.span>{' '}
              personas viendo en este momento
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}